<template>
  <div :class="(dark ? 'dark-mode' : '')" id="app" :style="(zoom ? 'zoom' : '')">
      
    <div class="modal-backdrop" :class="( modalActive ? 'blur' : 'backdrop-inactive' )"></div>
    <div class="modal-layer" :class="( modalActive ? 'modal-active' : 'modal-inactive' )">
      <div :class="( modalActive ? 'modal-enter' : 'modal-gone' )" class="modal">
        <Modal />
      </div>
    </div>

    <div id="nav" :class="( navTrigger ? 'lighteroni' : 'darkeroni' )">
      <router-link class="logo-link" to="/dashboard"><div class="logo-container">
        <div class="logo"></div>
      </div></router-link>

      <ul class="nav-inner">
        <!--router-link class="nav-item" v-if="!user && !admin" to="/register">
          <li><span>Sign up</span></li>
        </router-link-->
        <!--router-link class="nav-item" v-if="!isAuthenticated && !admin" to="/login">
          <li><span>Login</span></li>
        </router-link-->
        <router-link class="nav-item" v-if="isAuthenticated && !admin" to="/dashboard">
          <!-- if not admin, show user dashboard -->
          <li><div class="icon dash-icon"></div><span>Dashboard</span></li>
        </router-link>
        <router-link v-on:click.native="modulePage()" class="nav-item" v-if="isAuthenticated && !admin" to="/all_modules">
          <!-- if not admin, show all modules -->
          <li><div class="icon modules-icon"></div><span>All Modules</span></li>
        </router-link>
        <router-link class="nav-item" v-if="admin" to="/admin">
          <!-- if admin, show admin dashboard -->
          <li><div class="icon admin-icon"></div><span>Admin</span></li>
        </router-link>
        <router-link class="nav-item" v-if="isAuthenticated || admin" to="/resources">
          <!-- if logged in, show resources page -->
          <li><div class="icon res-icon"></div><span>Resources</span></li>
        </router-link>
      </ul>

      <div class="toggle-container">
        <div v-on:click="toggleDark" class="toggle"><div :class="(dark ? 'dark-button' : 'light-button')"></div></div>
      </div>

    </div>
    <div v-if="finished && !exit" class="completed-card">
        <h2>Congrats!!!</h2>
        <p>You've completed every module. You will recieve an email detailing next steps.</p>
        <div class="topbar"><div @click="handleCongratsExit()" class="exit">Return to dashboard</div></div>
    </div>
    <router-view />
  </div>
</template>

<script>
import firebase from "firebase";
import store from './store';
import Modal from '@/components/Modal.vue';

export default {
    data() {
        return {
            exit: false,
            userRef: null,
            builder: null,
            admin: null,
            isAuthenticated: false, //false by default, but true for testing
            profile: null
        };
    },
    components: {
      Modal
    },
    created() {
      //var self = this;

      /*if(window.devicePixelRatio >= 1.25) {
        this.zoom = true;
      }*/

      //whoever may be reading this, I hope you find what you're looking for

      try {
        var self = this;
        firebase.auth().onAuthStateChanged(userAuth => {  
          self.userRef = userAuth;
          //console.log(self.user.uid);
        //firebase.auth().currentUser.getIdTokenResult().then((claims) => {
            //console.log(claims);
            //self.user = claims.hbr;
            if(userAuth) {
              self.isAuthenticated = true;
            }
          //});
        });
      } catch(e) {
        console.log(e);
      }

      //self.isAuthenticated();
    },
    mounted() {

      /*window.addEventListener("keypress", function(e) {
        console.log(String.fromCharCode(e.keycode));
        if(e.keyCode == 32) {
          //self.start();
          store.commit('finish');
          console.log('commiting... global finish state: ', store.state.finished);
        }
      });*/

      //var self = this;

      /*try {
        setTimeout(() => {
          console.log('waiting a few................');
          //console.clear();
          console.log('...calling handleLoginEvent() + login()');
          this.login();
          this.handleLoginEvent();
        }, 5000);
      }
      catch(e) {
        console.error('whoops');
      }
      this.login();
      setTimeout(() => {
        //console.clear();
        //console.log('auth object', self.$auth);
        //console.log('profile', this.profile);
        //console.clear();
        //console.log(this.$auth);
      }, 2000);*/
    },    
    watch: {
      //'$route':'isAuthenticated'
    },
    computed: {
      modalActive() {
        return store.state.modalActive;
      },
      globalTrans() {
        return store.state.globalTrans;
      },
      dark() {
        return store.state.dark;
      },
      backColor() {
        return (store.state.dark ? '#212225' : 'red');
      },
      navGone() {
        return (!store.state.moduleClick);
      },
      lessonPage() {
        return store.state.lessonPage;
      },
      navTrigger() {
        return store.state.navTrigger;
      },
      finished() {
        return store.state.finished;
      }
    },
    methods: {
      toggleDark() {
        store.commit('toggleDark');
      },
      handleCongratsExit() {
        this.$confetti.stop();
        this.exit = true;
        store.commit('unfinish');
        //document.location.reload();
      },
      modulePage() {
        store.commit('modulePage');
        //console.log('context: ' + store.state.modulePage);
      },
      login() {
        //this.$auth.login();
        console.log('login call...');
      },
      logout() {
        //this.$auth.logOut();
      },
      handleLoginEvent(data) {
        //console.log('entered handleLoginEvent()...');
        //console.log('login data: ', data);
        this.isAuthenticated = data.loggedIn;
        this.profile = data.profile;
        //console.log(this.isAuthenticated);
        //console.log(this.profile);
      },
      /*async isAuthenticated() {
        this.authenticated = await this.$auth.isAuthenticated();
        console.log('authenticated?: ', this.authenticated);
      },*/

    }
    
};
</script>

<style lang="scss"> 
@import 'assets/global-styles/variables.scss';
@import url('https://fonts.googleapis.com/css2?family=Lato&family=Work+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Nunito&family=Nunito+Sans&display=swap');

* {
  transition: 300ms;
}

html {
  //filter: invert(1);
  //height: 100vh !important;
}

body {
  margin:0px;
  overflow: hidden;
  background: var(--back-color);
}

.download-export {
  text-align: center;
  margin-left: 18px;
  background: black;
  border-radius: 36px;
  line-height: 40px;
  height: 40px;
  width: 150px;
  color: white;
  cursor: pointer;
  font-weight: normal;

  &:hover {
    opacity: 0.5;
  }
}

.export-indicator {
  position: absolute;
  background: black;
  height: 60px;
  color: white;
  bottom: 0px;
  width: 100%;
  transition: 300ms;
  //padding-left: 32px;
  text-align: left;
  font-weight: bold;
  line-height: 60px;
  display: flex;
  align-items: center;
  //animation: rise-up ease forwards 2s;

  strong {
    margin-left: 32px;
  }
}

@keyframes rise-up {
  to {
    height: 60px;
  }
}

.completed-card {
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
    z-index: 99999;
    box-shadow: $softerShadow;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    margin: auto;
    text-align: center;
    border-radius: $rad;
    flex-direction: column;
    padding: $gap;
    width: 500px;
    height: 220px;
    opacity: 0;
    animation: flyin 1s ease forwards;

    h2 {
        margin-bottom: 0px;
    }

    p {
        opacity: 0;
        animation: flyin 1s ease forwards 1s;
    }
}

.topbar {
  padding: 12px;
  margin: 0px;
}

.exit {
  float: right;
  padding: 12px 24px;
  background: $colorBlue;
  border-radius: $rad;
  color: white;
  transition: 300ms;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
}

.logo-link {
  opacity: 1 !important;
}

.lighteroni {
  //filter: invert(0);
}

.darkeroni {
  //filter: invert(1);
}

.dark-mode {
  background: $colorDarkMid !important;
  .employee-name {
    color: black !important;
  }
  p, h1, h2, h3, h4, span:not(.employee-name) {
    color: white !important;
  }
  .auth-input {
    background: $colorDarkLight;
    color: white;
  }
  .auth-button {
    border: 2px white solid;
    color: white;

    &:hover {
      background: white;
      color: black;
    }
  }
  .greetings {
    color: $colorBlue !important;
  }
  .page-container {
    background: $colorDarkMid !important;
  }
  .dash-item-profile, .dash-item-recents, .dash-item-total, .dash-item-badges {
    background: $colorDarkLight !important;
  }
  .sign-out {
    background: transparent;
    border: solid 2px white !important;
    color: white !important;
    transition: 300ms;
    &:hover {
      background: white !important;
      color: black !important;
    }
  }
  .icon {
    filter: brightness(0) invert(1) !important;
  }
  .logo {
    background-image: url('assets/HBR-Logo-Blue.png') !important;
    filter: invert(1) brightness(2);
  }
  .chart-button {
    filter: invert(1) !important;
  }
  .chart-button-inactive {
    opacity: 0.2 !important;
  }
  #nav a {
    opacity: 0.2 !important;

    &.router-link-exact-active {
      opacity: 1 !important;
    }
  }
  .circle-progress::after, .circle-progress-snap::after {
    //background: red !important;
    color: white;
  }

}

#app {
  font-family: 'Nunito', Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

input {
  margin-bottom: 12px;
}

h4 {
    text-align: left;
    margin-top: 0px;
}

.page-container {
  margin: 0px;
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index:-1;
}

.profile-image-container {
  //background: gray;
  //border-radius: 100%;
  width: 40px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;

  .profile-image {
    width: 40px;
    height: 40px;
    //background: blue;
    border-radius: 100%;
    background-image: url('assets/account-icon.svg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

#nav {
  //padding: 24px;
  z-index: 12;
  background:transparent;
  position: fixed;
  width: 100%;
  height: $navHeight;
  display:flex;
  justify-content: center;

  .divider {
    opacity: 0.6;
    cursor: default;

    &:hover {
      background: transparent;
    }
  }

  li {
    //transition: 200ms; 
    display: flex;
    align-items: center;
    font-weight: bold;

    .icon {
      //background: black;
      width: 24px;
      height: 24px;
      margin-right: 12px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      filter: brightness(0);
      transition: $animationSpeed;
    }
  }

  .dash-icon {
    background-image: url("assets/icons/dashboard.svg");
  }

  .modules-icon {
    background-image: url("assets/icons/modules.svg");
    transform: rotate(90deg);
  }

  .res-icon {
    background-image: url("assets/icons/resources.svg");
  }

  .admin-icon {
    background-image: url("assets/icons/admin.svg");
  }

  .nav-inner {
    list-style: none;
    display: inline-flex;
    padding: 0px;
    //position: absolute;
    height: $navHeight;
    width: max-content;
    //right: 0px;
    margin: 0px;
    line-height: calc(#{$navHeight} + #{$gap});
    //margin-right: 24px;

    li {
      margin: 0px;
      padding-left: 24px;
      padding-right: 24px;
    }
  }

  a {
    font-weight:200;
    color: #2c3e50;
    //margin-left: 12px;
    //margin-right: 12px;
    text-decoration: none;
    opacity: 0.4;
    transition: $animationSpeed;

    &:hover {
      opacity: 0.7;
    }

    &.router-link-exact-active {
      color: black;
      font-weight: bold;
      opacity: 1;
      //text-decoration: underline;

      .icon {
        //filter: brightness(1);
      }
    }
  }
}

.toggle-container {
  //background: red;
  height: calc(#{$navHeight} + #{$gap});
  width: 64px;
  position: absolute;
  right: $gap;
  display: flex;
  justify-content: center;
  align-items: center;

  .toggle {
    cursor: pointer;

    &:hover {
      font-weight: bold;
    }
  }
}

.logo-container {
  //background: red;
  height: calc(#{$navHeight} + #{$gap});
  width: 128px;
  position: absolute;
  left: $gap;
  display: flex;
  justify-content: center;
  align-items: center;

  .logo {
    //background: yellow;
    height: $navHeight;
    width: 100%;
    background-image: url("assets/HBR-Logo-Blue.png");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 1 !important;
  }
}

.auth-button {
  background: transparent;
  border: solid 2px black;
  color: black;
  transition: 300ms;
  margin-top: 12px;
  border-radius: $rad;

  &:hover {
    background: black;
    color: white;
  }
}

.auth-input, .textbox {
  background: white;
  border:none;
  padding: 12px 24px;
  border-radius: $rad;
}

button {
    border: none;
    border-radius: $rad;
    background: hotpink;
    color: white;
    padding: 12px;
    cursor: pointer;
    font-weight: bold;
}

.export-button {
    background: black;
    padding: 0px 24px;
    border-radius: 200px;
    color: white;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    height: 40px;
    width: max-content;
    margin-left: auto;
    margin-right: auto;
    margin-top: 36px;

    &:hover {
        opacity: 0.4;
    }
}

//transition animation fade

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: scale(0.95);
}

.fade-enter-active, .fade-leave-active {
  transition: all 300ms ease;
}

//transition animation shift

.shift-enter, .shift-leave-to {
  opacity: 0;
  //transform: scale(0.5);
  //background: red !important;
    //transform: translateY(124px);
}

.shift-enter-active, .shift-leave-active {
  transition: all 300ms ease;
}

//transition animation leave

.gone-enter, .gone-leave-to {
    opacity: 0;
  //transform: scale(0.5);
  //background: red !important;
    transform: translateY(124px);

}

.gone-enter-active, .gone-leave-active {
  transition: all 300ms ease;
}

.dark-button {
  //background: red;
  width: 24px;
  height: 24px;
  background-image: url('assets/icons/sun.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  filter: invert(1);
  opacity: 0.4;
  transition: 300ms;

  &:hover {
    opacity: 1;
  }
}

.light-button {
  //background: red;
  width: 24px;
  height: 24px;
  background-image: url('assets/icons/moon.svg');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 0.4;
  transition: 300ms;
  //filter: invert(1);

  &:hover {
    opacity: 1;
  }
}

.modal-enter {
  opacity: 1;
  transform: scale(1);
  pointer-events: all;
}

.modal-gone {
  opacity: 0;
  transform: scale(0.8);
  pointer-events: none;
}

.modal-layer {
  height: calc(100vh - 80px);
  width: 100%;
  background: transparent;
  position: absolute;
  top: 80px;
  z-index: 9999;
  transition: 300ms;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  .modal {
    background: white;
    width: 800px;
    height: 500px;
    border-radius: 8px;
    margin-top: -80px;
    transition: 300ms;
  }
}

.modal-backdrop {
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0px;
  z-index: 9999;
  pointer-events: none;
  transition: 300ms;
}

.blur {
  backdrop-filter: blur(36px) brightness(0.9);
}
</style>
